export const ErrorCodes = {
  invalid_request: 'T-001',
  unsupported_platform: 'T-002',
  download_failed: 'T-003',
  network_error: 'T-004',
  configuration_error: 'T-005',
};

export const ErrorMessages = {
  'T-001': 'Invalid request. Please try again.',
  'T-002': 'This platform is not supported. Please select a different device.',
  'T-003': 'Download failed. Please try again or contact support.',
  'T-004': 'Network error. Please check your connection and try again.',
  'T-005': 'Configuration error. Please contact T-Mobile support.',
  'T-999': 'An unexpected error occurred. Please try again later.',
};
